import ResetPassword from 'pages/ResetPassword';
import {Route, Redirect, Switch} from 'react-router-dom';
import { LOGIN, NEW_PASSWORD, RESET_PASSWORD, CHOOSE_CONSOLE } from './routes';
import CreateNewPassword from 'pages/CreateNewPassword';
import SsoLogin from 'pages/SsoLogin';
import {PrivateRoute} from "./private-route";
import ChooseConsole from "../pages/ChooseConsole";
import {useLocation} from "react-router";
import {useEffect} from "react";
import {Userpilot} from "userpilot"

const AppRouter = () => {
  const location = useLocation()

  useEffect(() => {
    Userpilot.reload()
  }, [location])

  return (
      <Switch>
        <Route exact path="/">
          <Redirect to={LOGIN} />
        </Route>
        <Route path={LOGIN}>
          <SsoLogin />
        </Route>
        <Route path="/sso">
          <SsoLogin />
        </Route>
        <Route path={RESET_PASSWORD}>
          <ResetPassword />
        </Route>
        <Route path={NEW_PASSWORD}>
          <CreateNewPassword />
        </Route>
        <PrivateRoute path={CHOOSE_CONSOLE}>
          <ChooseConsole />
        </PrivateRoute>
      </Switch>
  );
};

export default AppRouter;
